export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7926.5647388b.jpg";